import React from 'react';
import ReactApexChart from 'react-apexcharts';

const AreaLineChart = ({ dashBoardData, isDark = false, isRtl = false, xTitle = 'XTitle', yTitle = 'YTitle' }) => {
  const chartColors = ['#1A2B5C', '#EE1D23', '#808080']; // Blue, Red, Gray

  const dataOptions = {
    series: dashBoardData.series,
    options: {
      chart: {
        type: 'area',
        height: 300,
        zoom: { enabled: false },
        toolbar: { show: true },
      },
      colors: chartColors,
      dataLabels: {
        enabled: true,
        style: {
          colors: [isDark ? '#e0e6ed' : '#191e3a'],
          fontSize: '12px',
        },
      },
      stroke: {
        width: 2,
        curve: 'smooth',
      },
      xaxis: {
        axisBorder: {
          color: isDark ? '#191e3a' : '#e0e6ed',
        },
        labels: {
          show: true,
          style: {
            colors: isDark ? '#e0e6ed' : '#191e3a',
            fontSize: '12px',
          },
        },
        title: {
          text: xTitle,
          style: {
            color: isDark ? '#e0e6ed' : '#191e3a',
            fontSize: '14px',
            fontWeight: 600,
          },
        },
      },
      yaxis: {
        labels: { show: true },
        title: {
          text: yTitle,
          style: {
            color: isDark ? '#e0e6ed' : '#191e3a',
            fontSize: '14px',
            fontWeight: 600,
          },
        },
      },
      labels: dashBoardData.categories,
      legend: {
        horizontalAlign: 'left',
        labels: {
          colors: isDark ? '#e0e6ed' : '#191e3a',
        },
      },
      grid: {
        borderColor: isDark ? '#191E3A' : '#E0E6ED',
        xaxis: {
          lines: {
            show: false,
          },
        },
      },
      tooltip: {
        theme: isDark ? 'dark' : 'light',
      },
    },
  };

  return (
    <div className="rounded-lg bg-white dark:bg-black overflow-hidden h-auto">
      <ReactApexChart series={dataOptions.series} options={dataOptions.options} type="area" height={400} />
    </div>
  );
};

export default AreaLineChart;
